import { render } from "./Card.vue?vue&type=template&id=54254404&scoped=true"
const script = {}

import "./Card.vue?vue&type=style&index=0&id=54254404&lang=postcss&scoped=true"
script.render = render
script.__scopeId = "data-v-54254404"

export default script